import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import VideoCollageSection from "../components/VideoCollageSection";
import DocsVideoCollageSection from "../components/DocsVideoCollageSection";
import ProductSection from "../components/ProductSection";
import TerminalSection from "../components/TerminalSection";
import StackSection from "../components/StackSection";
import HumanVoiceSection from "../components/HumanVoiceSection";
import KufibotSection from "../components/KufibotSection";
import AppsSection from "../components/AppsSection";
import { useT } from "../context/LanguageContext";
import ProcessSection from "../components/ProcessSection";
import IndustriesSection from "../components/IndustriesSection";
import ReferencesSection from "../components/ReferencesSection";
import PricingSection from "../components/PricingSection";
import BlogAndTestimonials from "../components/BlogAndTestimonials";
import FAQSection from "../components/FAQSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import AgentAccessModal from "../components/AgentAccessModal";

import ScrollNav from "../components/ScrollNav";

const SectionReveal = ({ id, children }) => (
  <motion.div
    id={id}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);


const HomePage = () => {
  const t = useT();
  useEffect(() => {
    // The browser may resolve the fragment before the React sections mount.
    const id = window.location.hash.slice(1);
    if (id !== "kufibot" && id !== "apps" && id !== "references") return;
    const scrollToSection = () => {
      if (window.location.hash.slice(1) !== id) return;
      document.getElementById(id)?.scrollIntoView({ behavior: "instant" });
    };
    const frame = requestAnimationFrame(scrollToSection);
    // Content above the references can change height while its assets load.
    if (id === "references" && document.readyState !== "complete") {
      window.addEventListener("load", scrollToSection, { once: true });
    }
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("load", scrollToSection);
    };
  }, []);
  const [agentOpen, setAgentOpen] = useState(false);
  const loginTarget = (process.env.REACT_APP_LOGIN_URL || "https://app.verasist.ai").trim();

  const handleLoginRedirect = () => {
    const target = loginTarget || "https://app.verasist.ai";
    const normalizedTarget =
      target.startsWith("http://") || target.startsWith("https://")
        ? target
        : `https://${target}`;

    window.location.assign(normalizedTarget);
  };

  const openAgent = () => setAgentOpen(true);
  const closeAgent = () => setAgentOpen(false);

  const sections = [
    { id: "hero", label: "Hero" },
    { id: "video", label: "Video" },
    { id: "product", label: "Ürün" },
    { id: "references", label: t("references.title") },
    { id: "terminal", label: "Terminal" },
    { id: "stack", label: "Stack" },
    { id: "human-voice", label: "İnsan Sesi" },
    { id: "kufibot", label: "Kufibot" },
    { id: "apps", label: t("apps.nav") },
    { id: "process", label: "Süreç" },
    { id: "industries", label: "Sektörler" },
    { id: "pricing", label: "Fiyatlandırma" },
    { id: "faq", label: "SSS" },
    { id: "docs-videos", label: "Dökümantasyon" },
    { id: "contact", label: "İletişim" },
  ];

  return (
    <div
      className="matrix-page overflow-x-hidden"
      style={{
        color: "var(--fg)",
        minHeight: "100vh",
      }}
    >
      <Navbar onTalkAgent={openAgent} />
      <main>
        <SectionReveal id="hero">
          <Hero onTalkAgent={openAgent} onGetStarted={handleLoginRedirect} />
        </SectionReveal>
        <div id="video">
          <VideoCollageSection />
        </div>
        <SectionReveal id="product">
          <ProductSection />
        </SectionReveal>
        <SectionReveal id="references">
          <ReferencesSection />
        </SectionReveal>
        <SectionReveal id="terminal">
          <TerminalSection />
        </SectionReveal>
        <SectionReveal id="stack">
          <StackSection />
        </SectionReveal>
        <SectionReveal id="human-voice">
          <HumanVoiceSection />
        </SectionReveal>
        <SectionReveal id="kufibot">
          <KufibotSection />
        </SectionReveal>
        <SectionReveal id="apps">
          <AppsSection />
        </SectionReveal>
        <SectionReveal id="process">
          <ProcessSection />
        </SectionReveal>
        <SectionReveal id="industries">
          <IndustriesSection />
        </SectionReveal>
        <SectionReveal id="pricing">
          <PricingSection />
        </SectionReveal>
        {/* <SectionReveal>
          <BlogAndTestimonials />
        </SectionReveal> */}
        <SectionReveal id="faq">
          <FAQSection onTalkAgent={openAgent} />
        </SectionReveal>
        <SectionReveal id="docs-videos">
          <DocsVideoCollageSection />
        </SectionReveal>
        <SectionReveal id="contact">
          <ContactSection />
        </SectionReveal>
      </main>
      <Footer />
      <AgentAccessModal
        open={agentOpen}
        onClose={closeAgent}
      />
      <ScrollNav sections={sections} />
    </div>
  );
};

export default HomePage;
